var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.52 219.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8bd00;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.44,60.04l-.16-.16-36.58-36.58-36.79,36.79v.5l.02.07v80.16l36.77,36.77,36.77-36.77v-23.14l-5.69-5.82.05-.08,5.64-8.83v-13.12h-.03v-29.78Zm-71.96.29l35.21-35.21,35.21,35.21-35.21,35.21-35.21-35.21Zm70.7,42.23l-.02.03-6.02,9.43,6.04,6.18v22.08l-34.84,34.84v-78.39l34.84-34.84v40.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.62,113.89c1.68.69,3.51.31,4.79-.98,3.49-3.54,5.41-8.22,5.41-13.19v-15.08l-12.93,13.09v12.1c0,1.81,1.04,3.37,2.72,4.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.83,126.74c0-1.8-1.03-3.34-2.69-4.02-.55-.23-1.12-.34-1.68-.34-1.13,0-2.22.45-3.06,1.3-3.54,3.59-5.49,8.34-5.49,13.38v15.92l12.93-13.09v-13.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.75,23.12L135.63,0l-23.12,23.12,23.12,23.12,23.12-23.12Zm-23.12-21l21,21-21,21-21-21,21-21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.39,99.22l-15.13,15.13,15.13,15.13,15.13-15.13-15.13-15.13Zm-13.01,15.13l13.01-13.01,13.01,13.01-13.01,13.01-13.01-13.01Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.83,
    y: 182.01,
    width: 19.65,
    height: 19.65,
    transform: "translate(-121.69 89.89) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.65,
    y: 205.8,
    width: 11.19,
    height: 11.19,
    transform: "translate(-118.36 137.04) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.19,
    y: 7.95,
    width: 34.7,
    height: 34.7,
    transform: "translate(-10.7 24.76) rotate(-45)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.8e6af1829d2a6e4957a36bca37f61b2f.svg";
export { ForwardRef as ReactComponent };